<h2 mat-dialog-title>{{model.targetDisplayTitle}}</h2>
<mat-dialog-content style="padding: 24px;">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="tabChanged($event)" style="height:155px" >
    <mat-tab label="Edit">
      <div style="display: flex; flex-direction: column;">
        <mat-form-field *ngIf="controlType!=='check' && controlType!=='folder'">
          <mat-label>New Value</mat-label>
          <div *ngIf="controlType==='text'">
            <input matInput [(ngModel)]="model.newFieldValue">
          </div>
          <div *ngIf="controlType==='date'" style="display: flex; flex-direction: row;">
            <input matInput [matDatepicker]="picker" [(ngModel)]="model.newFieldValue" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div *ngIf="controlType==='select'">
            <mat-select [(ngModel)]="model.newFieldValue">
              <mat-option *ngFor="let item of dropDownData" [value]="item.value">{{item.displayTitle}}</mat-option>
            </mat-select>
          </div>
        </mat-form-field>
        <section *ngIf="controlType==='check'" style="height: 60px;">
          <mat-checkbox matInput [(ngModel)]="checkboxState">{{checkboxText}}</mat-checkbox>
        </section>
        <div *ngIf="controlType==='folder'">
          <lex-folder-tree-view (clicked)="folderSelect($event)"></lex-folder-tree-view>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Field To Field" *ngIf="!isDocViewer">
      <div style="display: flex; flex-direction: column;">
        <mat-form-field>
          <mat-label>Source</mat-label>
          <mat-select (selectionChange)="sourceSelectionChanged($event)">
            <mat-optgroup *ngFor="let group of multiDocGroups" [label]="group.displayTitle">
              <mat-option *ngFor="let field of group.fields" [value]="field" [disabled]="field.disabled">
                {{field.displayTitle}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Destination</mat-label>
          <input matInput [value]="model.targetDisplayTitle" [readonly]="true" />
        </mat-form-field>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="multi-doc-edit-dialog-notice mat-caption" *ngIf="!isDocViewer">
    Note: Update Documents action might affect numerous documents and cannot be undone.
  </div>

  <mat-checkbox *ngIf="!expandEmailFamilySelected && !isDocViewer" [(ngModel)]="model.expandEmailFamily">Expand To Email Family</mat-checkbox>

</mat-dialog-content>

<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="ok()">{{okText}}</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
